module.exports = __webpack_public_path__ + "static/media/kidneys.df58e8f4.svg";